import React from 'react'
import PropTypes from 'prop-types'
import AutosizeInput from 'react-input-autosize'
import { formatMoney } from 'client/griffin'

const BACKSPACE_CHAR_CODE = 8
const TAB_CHAR_CODE = 9
const ENTER_CHAR_CODE = 13
const MIN_DIGIT_CHAR_CODE = 48
const MAX_DIGIT_CHAR_CODE = MIN_DIGIT_CHAR_CODE + 9

const MIN_DIGIT_CHAR_CODE_NUMPAD = 96
const MAX_DIGIT_CHAR_CODE_NUMPAD = MIN_DIGIT_CHAR_CODE_NUMPAD + 9

const MAX_LENGTH = 8

function dupeZeroes(numZeroes) {
  return new Array(Math.max(0, numZeroes + 1)).join('0')
}

class CurrencyTextBoxATM extends React.Component {
  static propTypes = {
    currencyCode: PropTypes.string,
    onChange: PropTypes.func,
    decimalDigits: PropTypes.number,
    value: PropTypes.number,
    autoResize: PropTypes.bool,
    showCurrency: PropTypes.bool,
    removeTrailingZeros: PropTypes.bool,
    focusOnMount: PropTypes.number,
  }

  static defaultProps = {
    value: 0,
    autoResize: false,
    removeTrailingZeros: false,
  }

  valuePropToState = valueProp => {
    return this.props.removeTrailingZeros
      ? valueProp.toString()
      : this.padZeroes(
          Math.round(valueProp * Math.pow(10, this.props.decimalDigits)) + ''
        )
  }

  UNSAFE_componentWillReceiveProps = ({ value }) => {
    if (value !== this.props.value) {
      this.setState({
        value: this.valuePropToState(value),
      })
    }
  }

  padZeroes = str => {
    const numOfZeroesToAdd = this.props.decimalDigits + 1 - str.length
    return dupeZeroes(numOfZeroesToAdd) + str
  }

  handleKeyDown = event => {
    let charCode = event.which || event.keyCode

    if (charCode === TAB_CHAR_CODE || charCode === ENTER_CHAR_CODE) {
      // tabs and enters are ok
      return
    }

    event.preventDefault()

    // Check for numpad keycodes, and "convert" them to regular char codes
    if (
      charCode >= MIN_DIGIT_CHAR_CODE_NUMPAD &&
      charCode <= MAX_DIGIT_CHAR_CODE_NUMPAD
    ) {
      charCode -= MIN_DIGIT_CHAR_CODE_NUMPAD - MIN_DIGIT_CHAR_CODE
    }

    // Get rid of non-numeric stuff
    if (
      charCode !== BACKSPACE_CHAR_CODE &&
      (charCode < MIN_DIGIT_CHAR_CODE || charCode > MAX_DIGIT_CHAR_CODE)
    ) {
      return
    }

    let newValue
    if (charCode === BACKSPACE_CHAR_CODE) {
      newValue = this.padZeroes(
        this.state.value.slice(0, this.state.value.length - 1)
      )
    } else {
      // Make sure we don't input too much
      if (this.state.value.length >= MAX_LENGTH) {
        return
      }
      const typedDigit = charCode - MIN_DIGIT_CHAR_CODE
      newValue = this.state.value + typedDigit
      newValue = this.padZeroes(newValue.replace(/^0+/, ''))
    }

    this.setState({ value: newValue })

    if (this.props.onChange) {
      const numValue = newValue * 1
      this.props.onChange(numValue / Math.pow(10, this.props.decimalDigits))
    }
  }

  handleFocus = () => {
    this.setState({ focus: true })
  }

  handleBlur = () => {
    this.setState({ focus: false })
  }

  formatMoneyForDisplay = stringValue => {
    const numValue = parseFloat(stringValue)
    if (numValue === 0 && !this.state.focus) {
      return ''
    }
    return formatMoney(
      this.props.currencyCode,
      numValue / Math.pow(10, this.props.decimalDigits),
      {
        removeTrailingZeros: this.props.removeTrailingZeros,
        showCurrencySymbol: this.props.showCurrency,
      }
    )
  }

  state = {
    value: this.valuePropToState(this.props.value),
    focus: false,
  }

  componentDidMount() {
    if (this.props.focusOnMount != null) {
      setTimeout(() => {
        if (this.inputElement) {
          this.inputElement.focus()
        }
      }, this.props.focusOnMount)
    }
  }

  render() {
    const inputProps = Object.assign({}, this.props)
    delete inputProps.currencyCode
    delete inputProps.decimalDigits
    delete inputProps.autoResize
    delete inputProps.showCurrency
    delete inputProps.removeTrailingZeros
    delete inputProps.focusOnMount
    delete inputProps.decimalDot
    delete inputProps.showIntlCurrencyCode

    inputProps.onKeyDown = this.handleKeyDown
    inputProps.onFocus = this.handleFocus
    inputProps.onBlur = this.handleBlur
    inputProps.value = this.formatMoneyForDisplay(this.state.value)
    inputProps.ref = inputElement => {
      this.inputElement = inputElement
    }

    if (this.props.autoResize) {
      inputProps.inputClassName = inputProps.className
      delete inputProps.className
      return <AutosizeInput {...inputProps} />
    }
    inputProps.type = 'text'
    return <input {...inputProps} />
  }
}

export default CurrencyTextBoxATM
